<template>
  <div class="customize-settings-page">
    
    <!-- Back Button -->
    <div class="customize-settings-page-header">
      <app-back-button 
        v-if="showBackButton"
        route-name="subpropertySettings" 
        i18n-code="subpropertySettings.menu" 
      />
    </div>


    <app-subproperty-customize-page
      v-if="showSubpropertyCustomizePage"
      :property-id="_propertyId"
      :subproperty-id="_subpropertyId"
    />
    <!-- <app-season-list-page v-else-if="activeTabIndex === tabs.seasons.index" /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { i18n } from '@shared/i18n';

import SubpropertyCustomizePage from '@modules/subproperty/components/subproperty-customize-page.vue';
import { get } from 'lodash';

export default {
  name: 'customize-settings-page',
  
  props: {
    propertyId: {
      type: String
    },
    subpropertyId: {
      type: String
    }
  },

  data() {
    return {
      tabs: {
        configuration: {
          type: 'configuration',
          label: i18n(
            'subpropertySettings.customize.configurationTab',
          ),
          index: 0,
          routerPush: {
            params: {
              tabType: 'configuration',
            },
          },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      currentUser: 'auth/currentUser',
      isRootScreen: 'layout/isRootScreen',
    }),

    showBackButton() {
      return this.currentManage.type === "subproperty"
    },

    _propertyId() {
      if (this.propertyId) return this.propertyId;
      else return get(this, 'currentManage.property.id', null)
    },
    _subpropertyId() {
      if (this.subpropertyId) return this.subpropertyId;
      else return get(this, 'currentManage.subproperty.id', null)
    },

    showSubpropertyCustomizePage() {
      return this._subpropertyId && (this.activeTabIndex === this.tabs.configuration.index) && this._propertyId;
    }
  },

  mounted() {
    this.setTabs(Object.values(this.tabs));
    this.parseActiveTab();
  },

  beforeDestroy() {
    this.resetTabs();
  },

  methods: {
    ...mapActions({
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex:
        'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
    }),

    parseActiveTab() {
      const routeTabIndex = this.$route.params.tabName;
      if (routeTabIndex)
        this.setActiveTabIndex(
          this.tabs[routeTabIndex].index,
        );
      else
        this.setActiveTabIndex(
          Object.values(this.tabs)[0].index,
        );
    },
  },

  components: {
    [SubpropertyCustomizePage.name]: SubpropertyCustomizePage,
  },

  watch: {
    $route: 'parseActiveTab',
  },
};
</script>

<style>
.text {
  font-size: 20px;
}

.card {
  padding-bottom: 20px;
}

.clearfix {
  font-size: 24px;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.clearfix button {
  float: right;
}

.space {
  margin-right: 20px;
}

.category-name {
  margin-bottom: 18px;
  clear: both;
}

.category-name div {
  float: right;
}

.category-name div button {
  padding-left: 5px;
}

.customize-settings-page-header {
  display: grid;
  grid-template-areas: 'back create';
}

.settings__create {
  grid-area: create;
  justify-self: end;
}
</style>

